import { render, staticRenderFns } from "./TeamSelectionModal.vue?vue&type=template&id=1c978664&scoped=true"
import script from "./TeamSelectionModal.vue?vue&type=script&lang=js"
export * from "./TeamSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./TeamSelectionModal.vue?vue&type=style&index=0&id=1c978664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c978664",
  null
  
)

export default component.exports